import { refreshReducersToInitial } from "./refreshData-action";

export type CustomerType = "customer" | "militaryBase";

export const UPDATE_SESSION_ID = "UPDATE_SESSION_ID" as const;
export const UPDATE_DISABLEMENT_ADDRESS = "UPDATE_DISABLEMENT_ADDRESS" as const;
export const CLEAR_DISABLEMENT_ADDRESS = "CLEAR_DISABLEMENT_ADDRESS" as const;
export const UPDATE_DESTINATION_ADDRESS = "UPDATE_DESTINATION_ADDRESS" as const;
export const REMOVE_DESTINATION_ADDRESS = "REMOVE_DESTINATION_ADDRESS" as const;
export const UPDATE_ADDITIONAL_COMMENTS = "UPDATE_ADDITIONAL_COMMENTS" as const;
export const UPDATE_FIRST_NAME = "UPDATE_FIRST_NAME" as const;
export const UPDATE_LAST_NAME = "UPDATE_LAST_NAME" as const;
export const UPDATE_OPERATOR_ID = "UPDATE_OPERATOR_ID" as const;
export const UPDATE_VEHICLE = "UPDATE_VEHICLE" as const;
export const UPDATE_PPU_FLAG = "UPDATE_PPU_FLAG" as const;
export const UPDATE_LOGGED_IN_FLAG = "UPDATE_LOGGED_IN_FLAG" as const;
export const UPDATE_CCARD_INFO = "UPDATE_CCARD_INFO" as const;
export const CLEAR_CCARD_INFO = "CLEAR_CCARD_INFO" as const;
export const UPDATE_SMS_OPT_IN = "UPDATE_SMS_OPT_IN" as const;
export const UPDATE_EMAIL = "UPDATE_EMAIL" as const;
export const UPDATE_CONTACT_NUMBER = "UPDATE_CONTACT_NUMBER" as const;
export const UPDATE_SERVICE_TYPE_OPTIONS = "UPDATE_SERVICE_TYPE_OPTIONS" as const;
export const UPDATE_ADDITIONAL_FIELDS = "UPDATE_ADDITIONAL_FIELDS" as const;
export const REMOVE_ADDITIONAL_FIELD = "REMOVE_ADDITIONAL_FIELD" as const;
export const UPDATE_APP_ID = "UPDATE_APP_ID" as const;
export const CLEAR_SERVICE_TYPE_OPTIONS = "CLEAR_SERVICE_TYPE_OPTIONS" as const;
export const UPDATE_PROMO_CODE = "UPDATE_PROMO_CODE" as const;
export const UPDATE_PARTNER_MEMBER_ID = "UPDATE_PARTNER_MEMBER_ID" as const;
export const UPDATE_USAGE_ID = "UPDATE_USAGE_ID" as const;
export const UPDATE_TOW_REASON = "UPDATE_TOW_REASON" as const;
export const UPDATE_REPLACEMENT_VEHICLE = "UPDATE_REPLACEMENT_VEHICLE" as const;
export const UPDATE_NO_DESTINATION_COMMENT_REQUEST = "UPDATE_NO_DESTINATION_COMMENT_REQUEST" as const;
export const APPEND_VEHICLE_COMMENT_REQUEST = "APPEND_VEHICLE_COMMENT_REQUEST" as const;
export const UPDATE_TOW_DISTANCE = "UPDATE_TOW_DISTANCE" as const;
export const UPDATE_CURRENT_MILEAGE = "UPDATE_CURRENT_MILEAGE" as const;
export const UPDATE_BUSINESS_NAME = "UPDATE_BUSINESS_NAME" as const;
export const UPDATE_RENTAL_DETAIL = "UPDATE_RENTAL_DETAIL" as const;
export const UPDATE_INCIDENT_REPORT_DETAILS = "UPDATE_INCIDENT_REPORT_DETAILS" as const;
export const UPDATE_SCHEDULED_SERVICE_DATE_TIME = "UPDATE_SCHEDULED_SERVICE_DATE_TIME" as const;
export const UPDATE_STACKED_INFO = "UPDATE_STACKED_INFO" as const;
export const UPDATE_MEMBER_ID = "UPDATE_MEMBER_ID" as const;
export const UPDATE_POST_FIX = "UPDATE_POST_FIX" as const;
export const CLEAR_INCIDENT_DATA = "CLEAR_INCIDENT_DATA" as const;
export const CLEAR_COMMENT_REQUEST = "CLEAR_COMMENT_REQUEST" as const;
export const CLEAR_SCHEDULED_SERVICE_DATE_TIME = "CLEAR_SCHEDULED_SERVICE_DATE_TIME" as const;
export const SET_PREVIOUS_TRANSACTION_AMOUNT = "SET_PREVIOUS_TRANSACTION_AMOUNT" as const;
export const UPDATE_CUSTOMER_TYPE = "UPDATE_CUSTOMER_TYPE" as const


export const clearCCardInfo = () => ({ type: CLEAR_CCARD_INFO } as const);
export const clearDisablementAddress = () => ({ type: CLEAR_DISABLEMENT_ADDRESS } as const);
export const clearServiceTypeOptions = () => ({ type: CLEAR_SERVICE_TYPE_OPTIONS } as const);
export const removeAdditionalField = (payload) => ({ type: REMOVE_ADDITIONAL_FIELD, payload } as const);
export const removeDestinationAddress = () => ({ type: REMOVE_DESTINATION_ADDRESS } as const);
export const updateAdditionalComments = (payload) => ({ type: UPDATE_ADDITIONAL_COMMENTS, payload } as const);
export const updateAdditionalFields = (payload) => ({ type: UPDATE_ADDITIONAL_FIELDS, payload } as const);
export const updateAppId = (payload) => ({ type: UPDATE_APP_ID, payload } as const);
export const updateBusinessName = (payload) => ({ type: UPDATE_BUSINESS_NAME, payload } as const);
export const updateCustomerType = (payload: CustomerType) => ({ type: UPDATE_CUSTOMER_TYPE, payload} as const);
export const updateCCardInfo = (payload) => ({ type: UPDATE_CCARD_INFO, payload } as const);
export const updateContactNumber = (payload: string) => ({ type: UPDATE_CONTACT_NUMBER, payload } as const);
export const updateCurrentMileage = (payload) => ({ type: UPDATE_CURRENT_MILEAGE, payload } as const);
export const updateDestinationAddress = (payload) => ({ type: UPDATE_DESTINATION_ADDRESS, payload } as const);
export const updateDisablementAddress = (payload) => ({ type: UPDATE_DISABLEMENT_ADDRESS, payload } as const);
export const updateEmail = (payload) => ({ type: UPDATE_EMAIL, payload } as const);
export const updateFirstName = (payload: string) => ({ type: UPDATE_FIRST_NAME, payload } as const);
export const updateIncidentReportDetails = (payload) => ({ type: UPDATE_INCIDENT_REPORT_DETAILS, payload } as const);
export const updateLastName = (payload: string) => ({ type: UPDATE_LAST_NAME, payload } as const);
export const updateLoggedInFlag = (payload) => ({ type: UPDATE_LOGGED_IN_FLAG, payload } as const);
export const updateMemberId = (payload) => ({ type: UPDATE_MEMBER_ID, payload } as const);
export const updateOperatorId = (payload) => ({ type: UPDATE_OPERATOR_ID, payload } as const);
export const updatePartnerMemberId = (payload) => ({ type: UPDATE_PARTNER_MEMBER_ID, payload } as const);
export const updatePpuFlag = (payload) => ({ type: UPDATE_PPU_FLAG, payload } as const);
export const updateRentalDetail = (payload) => ({ type: UPDATE_RENTAL_DETAIL, payload } as const);
export const updateSessionId = (payload) => ({ type: UPDATE_SESSION_ID, payload } as const);
export const updatePromoCode = (payload) => ({ type: UPDATE_PROMO_CODE, payload } as const);
export const updateScheduledServiceDateTime = (payload) =>
  ({ type: UPDATE_SCHEDULED_SERVICE_DATE_TIME, payload } as const);
export const updateServiceTypeOptions = (payload) => ({ type: UPDATE_SERVICE_TYPE_OPTIONS, payload } as const);
export const updateSmsOptIn = (payload) => ({ type: UPDATE_SMS_OPT_IN, payload } as const);
export const updateStackedInfo = (payload) => ({ type: UPDATE_STACKED_INFO, payload } as const);
export const updateTowDistance = (payload: { scalar: number; unitMeasure: string }) =>
  ({ type: UPDATE_TOW_DISTANCE, payload } as const);
export const updateTowReason = (payload: string) => ({ type: UPDATE_TOW_REASON, payload } as const);
export const updateReplacementVehicle = (payload: boolean) => ({ type: UPDATE_REPLACEMENT_VEHICLE, payload } as const);
export const updateCommentRequest = (payload: string) => ({ type: UPDATE_NO_DESTINATION_COMMENT_REQUEST, payload } as const);
export const appendVehicleCommentRequest = (payload: string) => ({ type: APPEND_VEHICLE_COMMENT_REQUEST, payload } as const);
export const updateUsageId = (payload) => ({ type: UPDATE_USAGE_ID, payload } as const);
export const updateVehicle = (payload) => ({ type: UPDATE_VEHICLE, payload } as const);
export const updatePostFix = (payload) => ({ type: UPDATE_POST_FIX, payload } as const);
export const clearIncidentData = () => ({ type: CLEAR_INCIDENT_DATA } as const);
export const clearCommentRequest = () => ({ type: CLEAR_COMMENT_REQUEST } as const);
export const clearScheduledServiceDateTime = () => ({ type: "CLEAR_SCHEDULED_SERVICE_DATE_TIME" } as const);
export const setPreviousTransactionAmount = (payload: string) => ({ type: SET_PREVIOUS_TRANSACTION_AMOUNT, payload } as const);

export type UpdateServiceRequestPayloadActions =
  | ReturnType<typeof clearCCardInfo>
  | ReturnType<typeof clearDisablementAddress>
  | ReturnType<typeof clearServiceTypeOptions>
  | ReturnType<typeof removeAdditionalField>
  | ReturnType<typeof removeDestinationAddress>
  | ReturnType<typeof updateAdditionalComments>
  | ReturnType<typeof updateAdditionalFields>
  | ReturnType<typeof updateAppId>
  | ReturnType<typeof updateBusinessName>
  | ReturnType<typeof updateCCardInfo>
  | ReturnType<typeof updateContactNumber>
  | ReturnType<typeof updateCurrentMileage>
  | ReturnType<typeof updateDestinationAddress>
  | ReturnType<typeof updateDisablementAddress>
  | ReturnType<typeof updateEmail>
  | ReturnType<typeof updateFirstName>
  | ReturnType<typeof updateIncidentReportDetails>
  | ReturnType<typeof updateLastName>
  | ReturnType<typeof updateLoggedInFlag>
  | ReturnType<typeof updateMemberId>
  | ReturnType<typeof updateOperatorId>
  | ReturnType<typeof updatePartnerMemberId>
  | ReturnType<typeof updatePpuFlag>
  | ReturnType<typeof updateRentalDetail>
  | ReturnType<typeof updateSessionId>
  | ReturnType<typeof updatePromoCode>
  | ReturnType<typeof updateScheduledServiceDateTime>
  | ReturnType<typeof updateServiceTypeOptions>
  | ReturnType<typeof updateSmsOptIn>
  | ReturnType<typeof updateStackedInfo>
  | ReturnType<typeof updateTowDistance>
  | ReturnType<typeof updateTowReason>
  | ReturnType<typeof updateReplacementVehicle>
  | ReturnType<typeof updateCommentRequest>
  | ReturnType<typeof appendVehicleCommentRequest>
  | ReturnType<typeof updateUsageId>
  | ReturnType<typeof updateVehicle>
  | ReturnType<typeof updatePostFix>
  | ReturnType<typeof clearIncidentData>
  | ReturnType<typeof refreshReducersToInitial>
  | ReturnType<typeof clearCommentRequest>
  | ReturnType<typeof clearScheduledServiceDateTime>
  | ReturnType<typeof setPreviousTransactionAmount>
  | ReturnType<typeof updateCustomerType>;
